<!--
  核销员列表
-->
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">展会管理</el-breadcrumb-item>
      <el-breadcrumb-item>展会预约管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-container>
      <el-main>
        <!-- 搜索筛选 -->
        <el-form :inline="true" label-position="right" label-width="100px" ref="formInline" :model="formInline" class="user-search">
          <el-form-item label="手机号" prop="phone">
            <el-input size="small" style="width: 200px;" v-model="formInline.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>

          <el-form-item label="请选择状态" prop="status">
            <el-select v-model="formInline.status" placeholder="请选择状态">
              <el-option :key="type.name" :label="type.name" :value="type.value"
                         v-for="type in statusSelect"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="所属场馆" prop="stadiumId">
            <el-select v-model="formInline.stadiumId" placeholder="请选择"  style="height: 33px;width: 250px;">
              <el-option
                v-for="item in staList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>


          <el-form-item>
            <el-button size="small" type="primary"  @click="resetFrom" >重置</el-button>
            <el-button size="small" type="primary" icon="el-icon-search" @click="tableList" >搜索</el-button>
            <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
          </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="small" :header-cell-style="{background:'#eef1f6',color:'#606266'}":data="listData"
                  highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">

          <template style="width: 100%" >
            <el-table-column prop="name" label="姓名" align="center"></el-table-column>
            <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
<!--            <el-table-column prop="area" label="展馆面积" align="center"></el-table-column>-->
            <el-table-column prop="event" label="展览项目" align="center"></el-table-column>
            <el-table-column prop="stadiumName" label="所属场馆" align="center"></el-table-column>
            <el-table-column prop="time" label="预约时间" align="center">
              <template slot-scope="scope">
                <div> {{scope.row.beginTime|timestampToTime}}--{{scope.row.endTime|timestampToTime}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" align="center">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status==0">待确定</el-tag>
                <el-tag v-if="scope.row.status==1">已预约</el-tag>
                <el-tag type="danger" v-if="scope.row.status==2">已拒绝</el-tag>
                <el-tag type="info" v-if="scope.row.status==3">已结束</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="申请时间" align="center">
              <template slot-scope="scope">
                <div> {{scope.row.createTime|timestampToTime}}</div>
              </template>
            </el-table-column>
<!--            <el-table-column prop="serial" label="展会号" align="center"></el-table-column>-->

            <el-table-column  label="操作" align="center" fixed="right" width="200px">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" v-if="scope.row.status==0" style="width: 100px;margin: 1px;" @click="handleEdit(scope.$index, scope.row)">修改预约信息</el-button>
                <el-button  size="mini" type="danger" v-if="scope.row.status==0" @click="submitResd(scope.row.id,2)">拒绝预约</el-button>
                <el-button  size="mini" type="primary" v-if="scope.row.status==0" class="title"  :disabled="isDisabled" @click="submitResd(scope.row.id,1)">同意预约</el-button>
<!--                <el-button size="mini" type="primary" v-if="scope.row.status==0" style="width: 100px;margin: 1px;" @click="handleEditResd(scope.$index, scope.row)">预约审核</el-button>-->
                <el-button size="mini" type="danger" v-if="scope.row.status==1" style="width: 100px;margin: 1px;" @click="statusEnd(scope.row.id)">提前结束</el-button>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click='closeDialog("edit")' :close-on-click-modal="false">
          <el-form label-width="120px" :model="editForm" ref="editForm"  :rules="rules">

            <el-form-item label="姓名" prop="name">
              <el-input size="small" v-model="editForm.name "  auto-complete="off" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
              <el-input size="small" v-model="editForm.phone "  auto-complete="off" placeholder="请输入手机号"></el-input>
            </el-form-item>
<!--            <el-form-item label="展馆面积" prop="area">-->
<!--              <el-input size="small" v-model="editForm.area "  auto-complete="off" placeholder="请输入展馆面积"></el-input>-->
<!--            </el-form-item>-->
            <el-form-item label="展览项目" prop="event">
              <el-input size="small" v-model="editForm.event "  auto-complete="off" placeholder="请输入展览项目"></el-input>
            </el-form-item>


<!--            <el-form-item label="布展时间" prop="arrBegin">-->
<!--              <el-date-picker-->
<!--                v-model="arrForm"-->
<!--                type="datetimerange"-->
<!--                format="yyyy-MM-dd HH:mm:ss"-->
<!--                value-format="yyyy-MM-dd HH:mm:ss"-->
<!--                range-separator="-"-->
<!--                start-placeholder="开始时间"-->
<!--                end-placeholder="结束时间">-->
<!--              </el-date-picker>-->
<!--            </el-form-item>-->

            <el-form-item label="预约时间" prop="beginTime">
              <el-date-picker
                v-model="baseForm"
                type="datetimerange"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="-"
                start-placeholder="开始时间"
                end-placeholder="结束时间">
              </el-date-picker>
            </el-form-item>

<!--            <el-form-item label="所属场馆" prop="stadiumId">-->
<!--              <el-select v-model="editForm.stadiumId" placeholder="请选择">-->
<!--                <el-option-->
<!--                  v-for="item in staList"-->
<!--                  :key="item.id"-->
<!--                  :label="item.name"-->
<!--                  :value="item.id">-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->

<!--            <el-form-item label="展会号" prop="serial">-->
<!--              <el-input size="small" v-model="editForm.serial" auto-complete="off" placeholder="请输入展会号"></el-input>-->
<!--            </el-form-item>-->
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
            <el-button size="small" type="primary" class="title"  :disabled="isDisabled" @click="submitForm('editForm')">保存</el-button>
          </div>
        </el-dialog>


        <!-- 预约审核 -->
        <el-dialog :title="title" :visible.sync="editResdVisible" width="30%" @click='closeDialog("edit")' :close-on-click-modal="false">
          <el-form label-width="120px" :model="editForm" ref="editForm" >

            <el-form-item label="展会号" prop="serial">
              <el-input size="small" v-model="editForm.serial" auto-complete="off" placeholder="请输入展会号"></el-input>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button  type="danger"  @click="submitResd('editForm',2)">拒绝预约</el-button>
            <el-button  type="primary" class="title"  :disabled="isDisabled" @click="submitResd('editForm',1)">同意预约</el-button>
          </div>
        </el-dialog>


      </el-main>
    </el-container>
  </div>
</template>

<script>
import {qryReservedList,upReserved,addReserved,upReservedStatus,upStatusEnd} from '../../api/platformApi'
import {qryStadiumList} from '../../api/courseApi'
import Pagination from '../../components/Pagination'
import {timestampToTime,parseTime} from "../../utils/util";
import {upEntranceStatus} from "../../api/examApi";
export default {
  name: "platform",
  data() {
    return {
      isDisabled: false,
      loading: false, //是显示加载
      title:'添加',
      editFormVisible:false,
      editResdVisible:false,
      formInline:{
        phone:'',
        status:'',
        stadiumId:'',
        page:1,
        pageSize:10
      },

      listData:[],
      baseForm:[],
      staList:[],
      arrForm:[],
      editForm:{
        id:'',
        name:'',
        phone:'',
        stadiumId:'',
        beginTime:'',
        endTime:'',
        area:'',
        event:'',
        status:'',
        serial:'',
        createTime:'',
        arrBegin:'',
        arrEnd:'',
      },
      // rules表单验证
      rules: {
        event: [
          { required: true, message: '请输入展览项目', trigger: 'blur' }
        ],

        phone: [
          { required: true, message: '手机号', trigger: 'blur' }
        ],
      },

      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      statusSelect:[{"name":"待确定","value":"0"},
        {"name":"已预约","value":"1"},
        {"name":"已拒绝","value":"2"},
        {"name":"已结束","value":"3"}],


    }
  },
  mounted() {
    this.tableList();
  },
  methods:{
    tableList(){
      this.loading = true;
      qryReservedList(this.formInline).then(res => {
        this.listData = res.data.list;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.pageSize;
        this.pageparm.total = res.data.total;
        this.loading = false;
      })

      qryStadiumList({pageSize:1000}).then(res => {
        this.staList = res.data;
      })
    },

    resetFrom(){
      this.formInline.stadiumId = '';
      this.formInline.status = '';
      this.formInline.phone = '';
      this.formInline.page = 1;
      this.formInline.pageSize = 10;
    },

    closeDialog(){
      this.$refs['editForm'].resetFields();
      this.baseForm =[]
      this.editFormVisible = false;
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改预约信息'
        this.editForm.id = row.id
        this.editForm.name = row.name
        this.editForm.phone = row.phone
        this.editForm.area=row.area
        this.editForm.event=row.event
        this.editForm.stadiumId=row.stadiumId
        this.editForm.serial=row.serial
        this.arrForm = [this.$moment(row.arrBegin).format("YYYY-MM-DD HH:mm:ss"),this.$moment(row.arrEnd).format("YYYY-MM-DD HH:mm:ss")]
        this.baseForm = [this.$moment(row.beginTime).format("YYYY-MM-DD HH:mm:ss"),this.$moment(row.endTime).format("YYYY-MM-DD HH:mm:ss")]
      } else {
        this.title = '添加'
        this.editForm.id = ''
        this.editForm.name = ''
        this.editForm.phone = ''
        this.editForm.area=''
        this.editForm.event=''
        this.editForm.stadiumId=''
        this.editForm.serial=''
        this.editForm.arrBegin=''
        this.editForm.arrEnd=''
        this.baseForm =[]
        this.arrForm =[]
      }
    },

    //显示预约
    handleEditResd: function(index, row) {
      this.editResdVisible = true
      this.title = '修改预约信息'
      this.editForm.id = row.id
      this.editForm.serial=row.serial
    },

    statusEnd(id) {
      this.$confirm('确认要提前结束吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var data={
          id:id
        }
        upStatusEnd(data).then(res =>{
          if (res.code==1) {
            this.$message({
              type: 'success',
              message: '数据保存成功！'
            })
            this.tableList(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        }).catch(err => {
          this.$message.error('保存失败，请稍后再试！')
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },

    // 编辑、添加提交方法
    submitForm(editData) {
      if (this.baseForm != ''&& this.baseForm != null) {
        // 开始时间
        this.editForm.beginTime = this.$moment(`${this.baseForm[0]}`)
        // 结束时间
        this.editForm.endTime = this.$moment(`${this.baseForm[1]}`)
      } else {
        // 删除开始时间
        delete this.editForm.beginTime;
        // 删除结束时间
        delete this.editForm.endTime;
        this.$message.error('保存失败，请选择预约时间！')
        return
      }



      if (this.arrForm != ''&& this.arrForm != null) {
        // 开始时间
        this.editForm.arrBegin = this.$moment(`${this.arrForm[0]}`)
        // 结束时间
        this.editForm.arrEnd = this.$moment(`${this.arrForm[1]}`)
      } else {
        // 删除开始时间
        delete this.editForm.arrBegin;
        // 删除结束时间
        delete this.editForm.arrEnd;
      }


      this.isDisabled = true;
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.editForm.id!=''){
            upReserved(this.editForm).then(res =>{
              if (res.code==1) {
                this.editFormVisible = false
                this.$message({
                  type: 'success',
                  message: '数据保存成功！'
                })
                this.tableList(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
              this.isDisabled = false;
            }).catch(err => {
              this.editFormVisible = false
              this.$message.error('保存失败，请稍后再试！')
              this.isDisabled = false;
            })
          }else{
            addReserved(this.editForm)
              .then(res => {
                if (res.code==1) {
                  this.editFormVisible = false
                  this.$message({
                    type: 'success',
                    message: '数据保存成功！'
                  })
                  this.tableList(this.formInline)
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
                this.isDisabled = false;
              })
              .catch(err => {
                this.editFormVisible = false
                this.$message.error('保存失败，请稍后再试！')
                this.isDisabled = false;
              })
          }
          // 请求方法
        } else {
          this.isDisabled = false;
          return false
        }
      })
    },


    //预约修改提交
    submitResd(id,status) {
      this.$confirm('确认要'+(status == 1?'通过':'拒绝')+'吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.isDisabled = true;
        var data ={
          status: status,
          id: id,
        }
        upReservedStatus(data).then(res =>{
          if (res.code==1) {
            this.editResdVisible = false
            this.$message({
              type: 'success',
              message: '数据保存成功！'
            })
            this.tableList(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
          this.isDisabled = false;
        }).catch(err => {
          this.editResdVisible = false
          this.$message.error('保存失败，请稍后再试！')
          this.isDisabled = false;
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });

    },

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.tableList();
    },
    handleAvatarSuccessOne(res) {
      this.editForm.image = res.data;
    },
    handleAvatarSuccessTwo(res) {
      this.editForm.banner = res.data;
    },
    beforeAvatarUpload(file) {
      //const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      /*if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }*/
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
  },
  //分页组件
  components: {
    Pagination
  }
}
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.redItem.el-form-item__label{
  color: #00ff80;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/platform/platform.vue